import _ from 'lodash'
const Object = {
	deepCopy: obj => {
		return _.cloneDeep(obj)
	},
	deepEqual: (objA, objB) => {
		return _.isEqual(objA, objB)
	},
}

export default Object
